import 'angular:locale/data:nb';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "nb";
